/**
 * Utilitaires pour les tableaux.
 */
export abstract class ArrayUtils {
	/**
	 * Transforme un objet d'attributs en une chaîne de caractères pour utilisation dans une balise HTML.
	 * @param attribs Objet contenant les attributs et leurs valeurs.
	 * @returns Chaîne de caractères représentant les attributs pour une balise HTML.
	 */
	static toStringAttribs(attribs: Record<string, any>): string {
		return Object.entries(attribs)
			.map(([key, value]) => `${key}="${value}"`)
			.join(' ');
	}

	/**
	 * Trie un tableau d'objets sur deux niveaux de dates (Descendant).
	 * @param arr Le tableau d'objets à trier.
	 * @param primarySelector Callback pour la date principale.
	 * @param secondarySelector Callback pour la date secondaire (fallback).
	 */
	static sortByDatesDescending<T>(
		arr: T[],
		primarySelector: (item: T) => Date | number,
		secondarySelector: (item: T) => Date | number,
	): T[] {
		return [...arr].sort((a, b) => {
			const dateA = this.#_getTime(primarySelector(a));
			const dateB = this.#_getTime(primarySelector(b));

			if (dateB !== dateA) {
				return dateA - dateB;
			}

			const subA = this.#_getTime(secondarySelector(a));
			const subB = this.#_getTime(secondarySelector(b));

			return subA - subB;
		});
	}

	/**
	 * Récupère le timestamp d'une Date ou d'un nombre.
	 * @param value Date ou nombre représentant un timestamp.
	 * @returns Le timestamp en millisecondes.
	 */
	static #_getTime(value: Date | number): number {
		return value instanceof Date ? value.getTime() : value;
	}
}
